import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionService } from '../modules/auth/services/session.service';

/**
 * Auth Interceptor
 * 
 * Dodaje Authorization header do każdego HTTP requestu.
 * Używa SessionService (nie AuthService!) aby uniknąć circular dependency.
 * 
 * Logika refresh tokena jest w TokenRefreshInterceptor.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private sessionService: SessionService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // NIE dodawaj Authorization header dla /auth/refresh (używa HttpOnly Cookie!)
    if (request.url.includes('/auth/refresh')) {
      return next.handle(request);
    }

    // Pobierz Authorization header z SessionService
    const authHeader = this.sessionService.getAuthorizationHeader();

    if (authHeader) {
      request = request.clone({
        setHeaders: {
          Authorization: authHeader
        }
      });
    }

    return next.handle(request);
  }
}
